import { mapUserObjectToUserOption } from '@atlassian/jira-base-user-picker/src/utils.tsx';
import { performIssueGetRequest } from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';

export const fetchSuggestions = async (autoCompleteUrl: string, query: string | null) => {
	let users = [];
	const url = `${autoCompleteUrl}${query || ''}`;
	const suggestionsResponse =
		(await performIssueGetRequest(url, undefined, 'fields/reporter/src/ui/edit/utils')) || [];

	if (Array.isArray(suggestionsResponse)) {
		// user/search returns array
		users = suggestionsResponse.map((userFromApi) => mapUserObjectToUserOption(userFromApi, true));
	} else if (suggestionsResponse.users) {
		// user/picker returns object
		// @ts-expect-error - TS7006 - Parameter 'userFromApi' implicitly has an 'any' type.
		users = suggestionsResponse.users.map((userFromApi) =>
			mapUserObjectToUserOption(userFromApi, true),
		);
	}
	return users;
};
